module.exports = __webpack_public_path__ + "static/media/Suraan3.89f5c699.jpg";